import { render, staticRenderFns } from "./AdminLayout.vue?vue&type=template&id=a59a5f66&scoped=true&lang=pug"
import script from "./AdminLayout.vue?vue&type=script&lang=ts"
export * from "./AdminLayout.vue?vue&type=script&lang=ts"
import style0 from "./AdminLayout.vue?vue&type=style&index=0&id=a59a5f66&prod&lang=scss&scoped=true"
import style1 from "./AdminLayout.vue?vue&type=style&index=1&id=a59a5f66&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a59a5f66",
  null
  
)

export default component.exports